import session from "./session";

export default {
  async loadLeadInfo(leadIdArr) {
    if (leadIdArr.length === 0) {
      return new Promise((resolve) => {
        resolve([]);
      });
    }
    const responsePromiseArr = [];

    leadIdArr.forEach((leadId) => {
      let res = session.get(`/leads/${leadId}/`);
      responsePromiseArr.push(res);
    });

    const resolvedPromiseArr = await Promise.all(responsePromiseArr);
    const response = resolvedPromiseArr.map((val) => val.data);

    return new Promise((resolve) => {
      resolve(response);
    });
  },
  createNewLead(payload) {
    return session.post(`/leads/`, JSON.stringify(payload));
  },
  addVoidReason({ leadId, payload }) {
    return session.patch(`/leads/${leadId}/`, payload);
  },
  addLostReason({ leadId, payload }) {
    return session.patch(`/leads/${leadId}/`, payload);
  },
  loadDailyLeads(options) {
    return session.get(`/leads/daily/?sort=creation_timestamp&order=desc&page=${options.paginationPage}&limit=${options.paginationLimit}&date=${options.date}&kind__in=${options.kind.join(",")}`);
  },
  getVoidReasons() {
    return session.get(`/static-data/options/?object_kind=Lead&field=void_reason`);
  },
  getLostReasons() {
    return session.get(`/static-data/options/?object_kind=Lead&field=lost_reason`);
  },
  assignSalesPerson({ leadId, payload }) {
    return session.patch(`/leads/${leadId}/`, payload);
  },
};
